{
  "error-handler-service": {
    "backend-message": {
      "customer": {
        "blackListed": "Votre option de réservation en ligne dans ce salon est bloquée. Veuillez contacter le salon pour prendre un nouveau rendez-vous",
        "existed": "Le compte existe déjà",
        "notFound": "Compte introuvable",
        "credentialNotMatched": "Le code PIN n'est pas valide. Veuillez réessayer !",
        "numberOfCredentialFailedMatchesAlreadyExceedMax": "Le nombre de tentatives est dépassé. Veuillez contacter le studio pour obtenir de l'aide supplémentaire.",
        "customerNumberOfCredentialResendExceedMax": "Le nombre de tentatives est dépassé. Veuillez contacter le studio pour obtenir de l'aide supplémentaire.",
        "waitingPeriodBeforeResendNotOverYet": "Veuillez patienter jusqu'à ce que vous puissiez renvoyer le code PIN après environ une minute."
      },
      "businessObject": {
        "alreadyCheckedIn": "Déjà enregistré. Veuillez réessayer dans quelques minutes",
        "notFound": "Studio introuvable"
      },
      "credit-package-order": {
        "no-capture-payments": "Échec de la commande d'un paquet de crédit",
        "order-already-fulfilled": "L'ordre du paquet de crédits a déjà été rempli",
        "order-already-rejected": "La commande de paquets de crédits a été refusée"
      },
      "email": {
        "exists-confirmed-and-not-changeable": "Une fois qu'un courriel a été confirmé, il ne peut plus être modifié !"
      },
      "error": {
        "email-exists": "Pour des raisons de sécurité, nous acceptons un e-mail unique associé à un numéro de téléphone unique. Votre numéro de téléphone est associé à un e-mail déjà utilisé. Veuillez essayer de vous connecter avec votre email.",
        "invalid-code": "Le code PIN n'est pas valide. Veuillez réessayer !",
        "phoneNr-exists": "Pour des raisons de sécurité, nous acceptons un e-mail unique associé à un numéro de téléphone unique. Votre adresse e-mail est associée à un numéro de téléphone déjà utilisé. Veuillez essayer de vous connecter avec votre numéro de téléphone."
      },
      "review": {
        "notFound": "URL invalide ou expiré"
      },
      "startTime": {
        "invalid": "Le créneau horaire sélectionné n'est plus disponible. Veuillez choisir un autre créneau horaire !"
      },
      "Unauthorized": "Veuillez vous reconnecter avec votre adresse e-mail et votre mot de passe corrects !",
      "user-challenge": {
        "too-much-requests": "Vous avez demandé fréquemment. Veuillez réessayer après quelques secondes"
      },
      "appointment duration is too long, max 4 hours": "La durée maximale est de 4 heures. Veuillez modifier les services sélectionnés.",
      "No available slot at desired start time": "Le créneau horaire sélectionné n'est plus disponible. Veuillez choisir un autre créneau horaire !",
      "confirmed appointment already exists at same time": "Vous avez déjà pris un rendez-vous à la même heure",
      "customer already has maximum number of confirmed appointments": "Le nombre maximum de rendez-vous dans ce salon a été atteint. Veuillez contacter le salon pour prendre un nouveau rendez-vous"
    },
    "text": {
      "server-connection-error": "Pas de connexion au serveur",
      "general-error": "Oups ! Un problème s'est produit. Veuillez réessayer plus tard."
    }
  }
}
